<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col text-left">
				<span class="address-info-city"> {{ selectedAddress.city_name }} -</span>
				<span class="address-info-street">{{ selectedAddress.city_street_name }}  </span>
				<span class="address-info-part"> ({{ selectedAddress.city_part_name }})  </span>
				<span class="address-info-number"> - {{ selectedAddress.number_popisne }}/{{ selectedAddress.number_orientacni}}{{ selectedAddress.sign_orientacni }} </span>
			</div>
		</div>

		<div class="row">
			<div class="col col-md-4 mt-2">
				<div class="address-addition" v-if="! bezdratMestaEditing"> Bezdrát na urovni města: {{ bezdratMesta }} <button class="btn btn-sm sedej" @click="bezdratMestaEditingToggle"> edit </button></div>
				<div class="input-group" v-else>
					<input class="form-control" v-model="newBezdratMesta" />
					<div class="input-group-append">
						<button class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="bezdratMestaEditingSave" > ✓ </button>
						<button class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="bezdratMestaEditingToggle"> X </button>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col col-md-4">
        		<div class="address-addition" v-if="! poznamkaAdresyEditing"> Poznámka: {{ poznamkaAdresy }} <button class="btn btn-sm sedej" @click="poznamkaAdresyEditingToggle"> edit </button> </div>
				<div class="input-group" v-else>
					<input class="form-control" v-model="newPoznamkaAdresy" />
					<div class="input-group-append">
						<button class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="poznamkaAdresyEditingSave" > ✓ </button>
						<button class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="poznamkaAdresyEditingToggle"> X </button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'


export default {
	name: 'AddressInfo',

    props: {
        selectedAddress: Object,
        bezdratMesta: String,
        poznamkaAdresy: String,
    },

	data () {
		return {
			bezdratMestaEditing: false,
			newBezdratMesta: null,
			poznamkaAdresyEditing: false,

		}
    },
    

	methods: {
        bezdratMestaEditingToggle () {
			this.newBezdratMesta = this.bezdratMesta
			this.bezdratMestaEditing = ! this.bezdratMestaEditing
        },
        
        async bezdratMestaEditingSave () {
			const hold = await AdditionsService.saveMestaBezdrat(this.selectedAddress.city_name, this.newBezdratMesta)

			if (hold.data) {
				this.bezdratMesta = this.newBezdratMesta
				this.bezdratMestaEditing = false
			}
        },
        
        poznamkaAdresyEditingToggle () {
			this.newPoznamkaAdresy = this.poznamkaAdresy
			this.poznamkaAdresyEditing = ! this.poznamkaAdresyEditing
		},



		async poznamkaAdresyEditingSave () {
			const hold = await AdditionsService.saveAdresniPoznamka(this.selectedAddress.adresni_misto, this.newPoznamkaAdresy)
			if (hold.data) {
				this.poznamkaAdresy = this.newPoznamkaAdresy
				this.poznamkaAdresyEditing = false
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
.address-info 
	display flex
	flex-direction row

.address-info-city 
	font-size 20px
	line-height 20px


.address-info-street 
	font-size 16px
	line-height 24px

.address-info-part 
	font-size 16px
	color gray
	line-height 22px

.address-info-number 
	font-size 20px
	line-height 20px
	padding-left 10px

.address-addition 
	text-align left

.sedej
	background-color #cccccc

</style>



// WEBPACK FOOTER //
// src/components/verifier/AddressInfo.vue